import { render, staticRenderFns } from "./BooleanField.vue?vue&type=template&id=f4038bd4&scoped=true&"
import script from "./BooleanField.vue?vue&type=script&lang=js&"
export * from "./BooleanField.vue?vue&type=script&lang=js&"
import style0 from "./BooleanField.vue?vue&type=style&index=0&id=f4038bd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4038bd4",
  null
  
)

export default component.exports